import format from "date-fns/format";
import { getFnsLocale } from "./dateTimeUtils";

export const translateDate = (date, lang, dateFormat = "d MMMM") =>
  date instanceof Date ? format(date, dateFormat, { locale: getFnsLocale(lang) }) : "";
